import { colors } from 's1-ui';

const { neutralWhite } = colors;

export default {
  typography: {
    fontFamily: 'Roboto, Arial',
    useNextVariants: true
  },
  palette: {
    text: {
      primary: neutralWhite,
      secondary: neutralWhite
    },
    primary: {
      main: neutralWhite,
      dark: neutralWhite
    },
    type: 'dark'
  }
};
